import * as MUTATIONS from '@/store/constants/mutations.js';

export const mutations = {
    [MUTATIONS.SET_IS_OUT_OF_DATE](state, is_out_of_date) {
        state.is_out_of_date = is_out_of_date;
    },
};
